import React, { useRef } from "react";
import { MultiSelect } from "react-multi-select-component";
import {
  AccountReducerAction,
  ClearProductCode,
  FetchSingleRecordAction,
  TierListReducerAction,
  addUserAction,
  clearGetSingleProjectDatabase,
  clearProjectId,
  popUpUpdate,
  updateAcccountReducerAction,
} from "../../../store/actions/createTicketManageFields";
// import swal from 'sweetalert';
import moment from "moment";
import {
  OneSiteDatabase,
  OneSiteDatabaseProjectCode,
  OneSiteDatabaseProjectId,
  accountApi,
  ixModule,
  managEngineer,
  ranDashboard,
  singleProjectApi,
  siteDblistSiteId,
  allTechnologyApi,
  runMpim,
  mpimpo,
  viewmpimpo,
  technology
} from "../../../common/config";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import DatePicker from "react-datepicker";
import {
  columnsArray,
  commonzone,
  fun_time_zonechanger,
  moment_common_full_date_format,
  reformArray,
} from "../../../common/variables";
import AdvancedCommonCrew from "../Forms/Ran Form/advancedcommoncrew";
import { useAsyncDebounce } from "react-table";
import { useHistory } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import Advcommoncrewupdated from "../Forms/Ran Form/advcommoncrewupdated";
// import DatePicker from "react-datepicker";
// const moment = require("moment");
const Tmo = () => {
  const formData = new FormData();
  let history = useHistory();
  let allProjects = [];
  let accountArry = [];
  let newTtempArray = [];
  let projectIdArray = [];
  let multipleTechno = [];
  let technologyArray = [];
  let dispatch = useDispatch();

  const [closer, setCloser] = useState(false);
  const currentYear = new Date().getFullYear();


  let [sow, setSow] = useState({
    selectedSow: [],
    sowList: [
      {
        label: "IX",
        value: "IX",
      },
      // {
      //   label: "NEA",
      //   value: "NEA"
      // },
      {
        label: "Troubleshooting",
        value: "Troubleshooting",
      },
      {
        label: "Call Test(PSAP/Speed Test)",
        value: "Call Test(PSAP/Speed Test)",
      },
    ],
    errorState: false,
  });

  let [showReason, setShowReason] = useState(false);
  let disableRef = useRef(false);
  let [disableButton, setDisable] = useState(false);
  let [singleSitestate, setsingleSitestate] = useState([]);
  let [tech, setTech] = useState([]);
  let [customesite, setcustomesite] = useState("");
  let [post, setPost] = useState([]);
  let [oneprid, setoneprid] = useState("");
  let [ppProjectId, setppProjctId] = useState("");
  let [SelselectProjectCode, setSelProjectCode] = useState([]);
  let [selectProjectId, setProjectId] = useState([]);
  let [siteError, setSiteError] = useState(false);
  let [ctrCount, setCtrCount] = useState(1);
  const [setdate, setStartDate] = useState();
  const [EngineerOpen, setEngineerOpen] = useState([]);
  const [fstartdate, setfstartdate] = useState();
  const [date, setdssate] = useState();
  const [datetime, setdssateee] = useState();

  let [selectProjectCode, setProjectCode] = useState([]);
  let [startDateError, setStartDateError] = useState(false);
  let siteArray = [];
  let projectCodeOption = [];
  let siteInfo = [];
  let engineerArray = [];
  let options = useSelector((state) => {
    let technology = state.CommonResponse.technology;
    if (technology.length > 0) {
      multipleTechno = [];
      if (technology.length > 0) {
        console.log("comeToStart");
        // setmultiTechnology([])
        console.log(technology, "technology");
        multipleTechno = technology.map((ids) => {
          // console.log("the ids -=", ids)
          // let pId = {
          //   label: ids.label,
          //   value: ids.label,
          //   disabled: true
          // }
          // multipleTechno.push(pId)
          // let tmpArry = []
          // tmpArry = technology.map((item) => {
          return {
            value: ids.uniqueid,
            label: ids.technologyName,
          };
          // });

          // multipleTechno.push(...tmpArry)
          // setmultiTechnology(multiTechnologylcl)
        });
        console.log(multipleTechno, "multiTechnologymultiTechnology");

        // settechsetter(false)
      }
      // }
    }

    siteInfo = state.csvResponse.singleSite;

    console.log("th e stacdsfcsd=", siteInfo);
    // console.log( siteInfo, siteInfo.length != 0, "ctrCount")
    if (ctrCount == 1 && siteInfo && siteInfo.length != 0) {
      console.log("the single site is =", siteInfo);
      setsingleSitestate(siteInfo);
      setCtrCount(2);
    }
    allProjects = state.CommonResponse.startAwaitedSite;
    console.log("all projects is =", allProjects);
    if (allProjects && allProjects.length > 0) {
      siteArray = allProjects.map((project) => {
        // console.log("the project is =========",project)
        return <option>{project.siteId}</option>;
      });
    }
    let account = state.CommonResponse.accounts;
    if (account.length > 0 && accountArry.length == 0) {
      accountArry = account.map((item) => {
        return <option value={item.uniqueid}>{item.accountName}</option>;
      });
    }
    let tier = state.CommonResponse.listtier;
    if (tier && tier.length != 0) {
      engineerArray = tier.map((item) => {
        return <option>{item.name}</option>;
      });
    }

    projectIdArray = state.OneCommonResponse.productId;
    if (projectIdArray && projectIdArray.length > 0) {
      let projectIdOption = projectIdArray.map((item, index) => {
        let availableId = [];
        let anyArry = item.data;
        availableId = item.data.map((id) => {
          return {
            label: id.projectId,
            value: id.uniqueid,
          };
        });

        newTtempArray.push({
          label: item.projectCode,
          value: item.projectCode,
          disabled: true,
        });
        newTtempArray.push(...availableId);
      });
    }

    if (state?.popUpState) {
      console.log(state.popUpState,"popUpStatestatusssssssss")
      if (
        (state?.popUpState?.popstatus?.status == 201 ||
          state?.popUpState?.popstatus?.status == 200) &&
        closer
      ) {
        setCloser(false);
        popUpUpdate({});

        // dispatch(AccountReducerAction(ixModule))
        // dispatch(AccountReducerAction(ixModule + "?ix=calender"));
        // history.push("a", { reload: true });
      }
    }

    let projectCodeArray = state.OneCommonResponse.productCode;
    if (projectCodeArray && projectCodeArray.length > 0) {
      projectCodeOption = projectCodeArray.map((item, index) => {
        console.log(
          SelselectProjectCode,
          item.projectCode,
          SelselectProjectCode.indexOf(item.projectCode),
          selectProjectCode.findIndex((abcd) => {
            console.log(abcd);
            return item.projectCode == abcd.label;
          }),
          "SelselectProjectCode"
        );
        if (
          SelselectProjectCode.indexOf(item.projectCode) >= 0 &&
          selectProjectCode.findIndex((abcd) => {
            return item.projectCode == abcd.label;
          }) == -1
        ) {
          selectProjectCode.push({
            value: item.uniqueid,
            label: item.projectCode,
          });
        }
        return {
          value: item.uniqueid,
          label: item.projectCode,
        };
      });
    }
    return { siteArray, projectCodeOption, engineerArray, accountArry };
  });
  const engineers = useSelector(state => state.CommonResponse.engineers)

  const accountss = useSelector(state => state.CommonResponse.accounts)

  const marketnames = useSelector(state => state.CommonResponse.marketName)


  console.log("the site id --dwef=", options.siteArray);

  // console.log(engineers, "engineers..engineers")
  console.log(accountss, "accountss..accountss")


  const techChangleHandler = (e) => {
    console.log("Pow multiple select=", e);
    setTech(e);
  };
  const postChangleHandler = (e) => {
    console.log("Pow multiple select=", e);
    setPost(e);
  };

  const findDSiteId = (id) => {
    console.log(id, "findDSiteId", allProjects);
    if (id != undefined && customesite != id) {
      setcustomesite(id);
      setoneprid("");
      setppProjctId("");
      setTech([]);
      setProjectId([]);
      setProjectCode([]);
      dispatch(clearGetSingleProjectDatabase());
      dispatch(clearProjectId());
      dispatch(ClearProductCode());
      // projectData.singleSite = []
      if (allProjects.length > 0)
        console.log(
          "the respasfsdvgfdsbdtrh =",
          ...allProjects.filter((item) => item.siteId == id)
        );
      let idObject = allProjects.filter((item) => item.siteId == id);
      if (idObject.length > 0) {
        // setond(true)

        // dispatch(FetchSingleRecordAction(projectCode, allProjects.filter((item) => item.siteId == id)[0].uniqueSiteId))   //from project Databasee
        dispatch(
          FetchSingleRecordAction(
            OneSiteDatabaseProjectCode,
            allProjects.filter((item) => item.siteId == id)[0].uniqueSiteId
          )
        ); //from network Databasee
      }
    } else {
      // setSiteError(true)
    }
  };

  const setHandler = (e) => {
    setSow((prev) => {
      return { ...prev, selectedSow: e, errorState: false };
    });
  };
  const {
    register,
    getValue,
    setValue,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    console.log(data, "dhakjggggg")

    const newData = new FormData()
    Object.keys(data).map((i) => {
      console.log("dwdwendwkjndwnf", i)
      newData.append(i, data[i])
    })


    // data["date"] = moment(date).format("DD/MM/YYYY")
    // data["datetime"] = moment(datetime).format("DD/MM/YYYY")



    // newData.append("site_id", data["site_id"]);
    // newData.append("Analysis_Status", data["Analysis_Status"]);
    // newData.append("inc_ticket", data["inc_ticket"]);
    // newData.append("xPEX", data["xPEX"]);
    // newData.append("bridge_support", data["bridge_support"]);
    // newData.append("assigned_to", data["assigned_to"]);
    // newData.append("shift", data["shift"]);
    // newData.append("hoReqired_to", data["hoReqired_to"]);
    // newData.append("notes", data["notes"]);
    // newData.append("ho_engineer", data["ho_engineer"]);


    // formData.append("type", data["type"])

    if (data.unique != undefined) {
      dispatch(
        updateAcccountReducerAction(
          formData,
          mpimpo,
        )
      );
      console.log(updateAcccountReducerAction, 'hhhhhh')
      setCloser(true)
    } else {
      console.log("kjhwgjfdgewjfuew", data)
      dispatch(addUserAction(mpimpo, data, undefined , () => { history.push('/mpim/podashboard') }))
    }


    popUpUpdate({});

    // dispatch(addUserAction(ixModule, data));
    setCloser(true);
  };
  const FetechAllDetail = (id) => {
    // let test = projectIdArray.filter((item) => item.uniqueid == id)[0]
    // console.log(test, "test")
    // setPId(id)
    // setppProjctId(id)
    setProjectId(id);
    let selectedId = id.map((item) => {
      return item.value;
    });
    // dispatch(FetchSingleRecordAction(ranDashboard, selectedId));
    dispatch(FetchSingleRecordAction(OneSiteDatabase, selectedId.join(",")));
    // setCtrCount(1)
    setValue("projectUniqueId", selectedId.join(","));
    // /console.log("FetechAllDetail", id)
  };
  console.log(
    "the col =",
    columnsArray(
      "S.no	Site ID	Project Type	Project ID	RTT Actual	DIY Vendor	Integrator Name	GC	Monitoring start Date	Time Monitoring Start (CST TZ)	0 Hour Status	0 Hr Rprt Sent	24 Hour Status	24 Hr Rprt Sent	48 Hour Status	48 Hr Rprt Sent	72 Hour Status	72 Hr Rprt Sent	Final Status	Integration Alarm Free report	End (CST TZ)	Comments	Unlock Date by RF"
    )
  );
  const findDProjectId = (id, def = 0, pcode = []) => {
    // setCountRender(1)
    // console.log("projectCodeArray", id, projectCodeArray)
    // setppProjectCode(id)

    // setppProjctId('')
    let selectedIds = [];
    let nselectedIds = "";
    if (def == 0) {
      setProjectCode(id);
      selectedIds = id.map((item) => {
        return item.value;
      });
      nselectedIds = selectedIds.join(",");
    } else {
      let testpcode = [];

      // testpcode=projectCodeArray.map((ittm)=>{
      //   if(pcode.indexOf(ittm.label)!=-1){
      //     return {
      //       label:ittm.label,
      //       value:ittm.value
      //     }
      //   }
      // })
      // setProjectCode(testpcode)
      nselectedIds = id;
    }
    // console.log(OneSiteDatabase + id, id, projectCodeArray, "projectCodeArray")

    setSelProjectCode(nselectedIds.split(","));
    setValue("projectCode", nselectedIds);
    setValue("projectcodeUniqueId", selectedIds.join(","));
    dispatch(FetchSingleRecordAction(OneSiteDatabaseProjectId, nselectedIds));
    setoneprid(id);
  };

  useEffect(() => {
    // dispatch(AccountReducerAction(siteDblistSiteId));
    // dispatch(TierListReducerAction(managEngineer));
    // dispatch(AccountReducerAction(allTechnologyApi));
    // // dispatch(AccountReducerAction(allTechnologyApi));
    dispatch(AccountReducerAction(mpimpo));
    dispatch(AccountReducerAction('/manage_engineer_name'));
    dispatch(AccountReducerAction('/manage_account_name'));
    dispatch(AccountReducerAction('/manage_market_name'));

  }, []);





  console.log(errors, "shyam console")

  const ossNames = ["", "POL2ENM", "POL0ENM", "POL3ENM1", "POL4ENM1", "POL5ENM1", "POL7ENM1", "POL8ENM1", "POL9ENM1", "SYL0ENM1", "SYL1ENM1", "SYL2ENM1", "SYL3ENM1", "SYL4ENM1", "SYL5ENM1", "SYL6ENM1", "SYL7ENM1", "SYL8ENM1", "SYL9ENM1", "SYLDENM1"];


  const years = [];
  for (let year = 2016; year <= currentYear; year++) {
    years.push(year);
  }




  return (
    <fregment className="m-6">
      <form className="form-row" onSubmit={handleSubmit(onSubmit)}>

      <div className="form-group col-md-3">
          <label htmlFor="year">YEAR<span style={{ color: "red" }}>*</span></label>
          <select
            style={{ height: "32px" }}
            name="year"
            className="custom-select-style form-control"
            required
            {...register("year")}
          >
            <option selected disabled value="">
              Select...
            </option>
            {years.map((year) => {
              return <option key={year} value={year}>
                {year}
              </option>
            })}
          </select>
        </div>




        <div className="form-group col-md-3">
          <label htmlFor="inputEmail4">MONTH<span style={{ color: "red" }}>*</span></label>

          <select
            style={{ height: "32px" }}
            type="text"
            name="month"
            className="custom-select-style form-control"
            required
            {...register("month")}
          >
            <option selected disabled value="">
              Select...
            </option>
            <option value="JAN">JAN</option>
            <option value="FEB">FEB</option>
            <option value="MAR">MAR</option>
            <option value="APR">APR</option>
            <option value="MAY">MAY</option>
            <option value="JUN">JUN</option>
            <option value="JUL">JUL</option>
            <option value="AUG">AUG</option>
            <option value="SEP">SEP</option>
            <option value="OCT">OCT</option>
            <option value="NOV">NOV</option>
            <option value="DEC">DEC</option>

          </select>
          {/* {errors.sheduleShift && (
            <p className="error">{errors.sheduleShift.message}</p>
          )} */}
        </div>


        <div className="form-group col-md-3">
          <label htmlFor="inputEmail4">ACTIVITY<span style={{ color: "red" }}>*</span></label>

          <select
            style={{ height: "32px" }}
            type="text"
            className="custom-select-style form-control"
            required
            {...register("activity")}
          >
            <option selected disabled value="">
              Select...
            </option>
            <option value="CAPEX">CAPEX</option>
            <option value="OPEX">OPEX</option>
          </select>


          {/* {errors.sheduleShift && (
            <p className="error">{errors.sheduleShift.message}</p>
          )} */}
        </div>

        {/* <div className="form-group col-md-3">
          <label htmlFor="inputEmail4">Activity<span style={{ color: "red" }}>*</span></label>

          <select
            style={{ height: "32px" }}
            type="text"
            className="custom-select-style form-control"
            {...register("activity")}
          >
            <option selected disabled value="">
              Select...
            </option>
            <option value="CAPEX">CAPEX</option>
            <option value="OPEX">OPEX</option>
          </select>


        
        </div> */}

        <div className="form-group col-md-3">
          <label htmlFor="inputEmail4">PO</label>
          <input
            style={{ height: "32px" }}
            type="text"
            min={0}
            max={100}
            className="form-control"
            id="inputEmail4"
            name="po"
            {...register("po")}
          />
        </div>

        <div className="form-group col-md-3">
          <label htmlFor="inputEmail4">QUANTITY</label>
          <input
            style={{ height: "32px" }}
            type="text"
            min={0}
            max={100}
            className="form-control"
            required
            id="inputEmail4"
            name="quantity"
            {...register("quantity")}
          />
        </div>


        {/* <div className="form-group col-md-3">
          <label htmlFor="inputEmail4">ACTUAL</label>
          <input
            style={{ height: "32px" }}
            type="text"
            min={0}
            max={100}
            className="form-control"
            required
            id="inputEmail4"
            name="actual"
            {...register("actual")}
          />
        </div> */}


        <div
          className="d-flex justify-content-center mb-5"
          style={{ width: "100%" }}
        >
          <button
            type="submit"
            className="btn btn-primary btn-xs py-2 mr-2 px-4 mt-2"

          >
            Submit
          </button>

          {/* <button
            className="btn btn-danger btn-xs py-2  px-4 mr-2 mt-2"
            onClick={() => history.push("/PAG/ix/dashboard")}
          >
            Back
          </button> */}
        </div>
      </form>
    </fregment>
  );
  
};


export default Tmo;
